var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssigned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#1F2A37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.12 15.28C14.05 15.27 13.96 15.27 13.88 15.28C12.12 15.22 10.72 13.78 10.72 12.01C10.72 10.2 12.18 8.72998 14 8.72998C15.81 8.72998 17.28 10.2 17.28 12.01C17.27 13.78 15.88 15.22 14.12 15.28Z",
    stroke: "#F9FAFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.74 21.8801C18.96 23.5101 16.6 24.5001 14 24.5001C11.4 24.5001 9.04001 23.5101 7.26001 21.8801C7.36001 20.9401 7.96001 20.0201 9.03001 19.3001C11.77 17.4801 16.25 17.4801 18.97 19.3001C20.04 20.0201 20.64 20.9401 20.74 21.8801Z",
    stroke: "#F9FAFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24.5C19.5228 24.5 24 20.0228 24 14.5C24 8.97715 19.5228 4.5 14 4.5C8.47715 4.5 4 8.97715 4 14.5C4 20.0228 8.47715 24.5 14 24.5Z",
    stroke: "#F9FAFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigned);
export default __webpack_public_path__ + "static/media/assigned.afd863f6712f66854a04edbd1781777d.svg";
export { ForwardRef as ReactComponent };